import { css } from "@emotion/css"
import { signInWithEmailAndPassword, getAuth } from "firebase/auth"
import { useState } from "react"
import { useKey } from "react-use"

export const Login: React.FC = () => {
  const [email, setEmail] = useState("")
  const [password, setPassword] = useState("")
  const [error, setError] = useState<string | null>(null)

  const login = () => {
    if (!email || !password) return
    signInWithEmailAndPassword(getAuth(), email, password).catch((err) => {
      setError(err.message)
    })
  }

  useKey(
    (e) => e.key === "Enter",
    () => {
      login()
    }
  )

  return (
    <div
      className={css`
        position: fixed;
        width: 100vw;
        height: 100vh;
        display: flex;
        justify-content: center;
        align-items: center;
      `}
    >
      <div
        className={css`
          width: 400px;
        `}
      >
        <input
          type="text"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="email"
          className={css`
            margin-bottom: 10px;
            background-color: #f7f7f7;
            width: 100%;
            height: 50px;
            padding-left: 20px;
            border-radius: 6px;
            font-size: 22px;
            border: none;
          `}
        />
        <input
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder="password"
          className={css`
            margin-bottom: 10px;
            background-color: #f7f7f7;
            width: 100%;
            height: 50px;
            padding-left: 20px;
            border-radius: 6px;
            font-size: 22px;
            border: none;
          `}
        />
        <div
          onClick={login}
          className={css`
            width: 100px;
            margin: 20px;
            background-color: #e7e7e7;
            cursor: pointer;
            padding: 10px;
            border-radius: 10px;
            text-align: center;
            &:hover {
              background-color: #d7d7d7;
            }
          `}
        >
          <div>log in</div>
        </div>
        {error ? <p style={{ color: "red" }}>{error}</p> : null}
      </div>
    </div>
  )
}
